'use client'

import { memo } from 'react'

import { ErrorDataUnavailable } from '@/components/common/Error'

const ChartTotalBorrowError = () => {
  return <ErrorDataUnavailable minHeight="395px" />
}

export default memo(ChartTotalBorrowError)
